import React from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import userService from "../../../services/user.service";
import backIcon from "../../../assets/images/public/back-icon.png";
import { Spinner, MessageAlert } from "../..";
import { SignUpForm } from "./signUpForm";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import { connect } from "react-redux";
import CamelCaseString from "../../../Common/CamelCaseString";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import { fullPageLoading } from "../../../Redux/Actions/LoadingActions";
class signUp extends React.Component {
  constructor() {
    super();
    this.state = {
      countryList: [],
      schoolTypeList: [],
      allSportsList: [],
      stateList: [],
      uploadId: null,
      loading: false,
      open: false,
      message: "",
      visible: false,
      msg: "",
      redirect: false,
    };
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ open: false });
  };

  componentDidMount() {
    this.getAllCountryList();
    this.getschoolTypeList();
    this.getAllSportsList();
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  getAllSportsList = () => {
    userService.getAllSports().then((response) => {
      var allSportsList = response.data.data;
      this.setState({ allSportsList: [allSportsList] });
    });
  };

  getschoolTypeList = () => {
    userService.getAllSchoolType().then((response) => {
      var schoolTypeList = response.data.data;
      this.setState({ schoolTypeList });
    });
  };

  getAllCountryList = () => {
    userService.getAllCountries().then((response) => {
      var countryList = response.data.data;
      this.setState({ countryList });
    });
  };

  handleChangeCoutry = (countryName) => {
    const { countryList } = this.state;
    let countryObject = countryList.find(({ name }) => name === countryName);
    if (countryObject?.id) {
      userService.getAllStateOfCountry(countryObject?.id).then((response) => {
        this.setState({
          stateList: response?.data?.data || [],
        });
      });
    } else {
      this.setState({
        stateList: [],
      });
    }
  };

  setLoader = (status) => this.setState({ loading: status });

  submitSignUp = (values, resetForm) => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      country,
      state,
      schoolName,
      schoolType,
      sport,
      signUpMessage,
      playLevel,
      captchaValue,
    } = values;
    const { uploadId } = this.state;
    const { setSuccessPopupInformation, fullPageLoading } = this.props;
    fullPageLoading(true);
    userService
      .signUpApi(
        CamelCaseString(firstName),
        CamelCaseString(lastName),
        email,
        phoneNumber,
        country,
        state,
        CamelCaseString(schoolName),
        schoolType,
        sport,
        CamelCaseString(signUpMessage),
        uploadId,
        playLevel,
        captchaValue
      )
      .then((res) => {
        const { success, data } = res.data;
        if (success) {
          setSuccessPopupInformation({
            successPopUp: {
              message:
                "Thank You For Registering. Please Check Your Email To Complete The Sign Up.",
              open: true,
            },
          });

          resetForm({ values: "" });
          fullPageLoading(false);
        } else {
          throw new Error(data);
        }
      })
      .catch((error) => {
        fullPageLoading(false);
        this.setState({
          visible: true,
          message: error.response?.data?.data
            ? error.response?.data?.data
            : error.message,
        });
      });
  };

  handleCloseMessageBox = (visible) => this.setState({ visible });

  render() {
    const { countryList, message, loading, visible, redirect } = this.state;

    if (redirect) {
      return <Redirect to="/login" />;
    }
    return (
      <>
        <section className="guidlelines-section">
          <div className="guidlelines-container signup-container">
            <div className="signup-back-title-container">
              <div className="screen-title-container signup-title-container">
                <div className="screen-title-content">
                  <Link className="back-button-container" to="/">
                    <img src={backIcon} alt="back" />
                  </Link>
                  <div>
                    Sign <span>Up</span>
                  </div>
                </div>
              </div>
              <div className="faq-section">
                <div>
                  Enter the details below to register your school and start
                  using ContendZone platform
                </div>
              </div>
            </div>
            <div className="signup-form-container">
              <SignUpForm
                countryList={countryList}
                submitSignUp={this.submitSignUp}
              />
            </div>
          </div>
        </section>
        <MessageAlert
          message={message}
          handleCloseMessageBox={() => this.handleCloseMessageBox(false)}
          open={visible}
          color="red"
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
    fullPageLoading: (obj) => fullPageLoading(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(signUp));
